module.exports = __webpack_public_path__ + "img/icn_epa.ac413d97.svg";